import { Mail, Instagram, MessageCircle } from "lucide-react";
import { Card } from "@/components/ui/card";
const Contact = () => {
  return <section className="section-padding container-custom bg-[#f8f6f2]">
      <div className="space-y-8 sm:space-y-12">
        <div className="text-center space-y-3 sm:space-y-4 px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-foreground">
            Get in Touch
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground">
            Have questions? I'd love to hear from you
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-4xl mx-auto px-4">
          <Card className="card-enhanced p-5 sm:p-6 text-center space-y-4 border-border">
            
            <div>
              <h3 className="font-semibold text-card-foreground mb-2 text-base sm:text-lg">Email</h3>
              <a href="mailto:contact@nikitasinghal.com" className="text-sm sm:text-base text-muted-foreground hover:text-accent transition-colors break-all">renewsantulan@gmail.com</a>
            </div>
          </Card>

          <Card className="card-enhanced p-5 sm:p-6 text-center space-y-4 border-border">
            
            <div>
              <h3 className="font-semibold text-card-foreground mb-2 text-base sm:text-lg">Instagram</h3>
              <a href="https://instagram.com/renewsantulan" target="_blank" rel="noopener noreferrer" className="text-sm sm:text-base text-muted-foreground hover:text-accent transition-colors">
                @renewsantulan
              </a>
            </div>
          </Card>

          <Card className="card-enhanced p-5 sm:p-6 text-center space-y-4 border-border sm:col-span-2 lg:col-span-1">
            
            <div>
              <h3 className="font-semibold text-card-foreground mb-2 text-base sm:text-lg">WhatsApp</h3>
              <a href="https://wa.me/919910961228" target="_blank" rel="noopener noreferrer" className="text-sm sm:text-base text-muted-foreground hover:text-accent transition-colors inline-block">
                +91 99109 61228<br />
                <span className="text-xs">Chat with us anytime</span>
              </a>
            </div>
          </Card>
        </div>
      </div>
    </section>;
};
export default Contact;